"use strict";
const { saveConfig } = require("./utils");
function bootstrap() {
  saveConfig();
}
export default bootstrap;
